import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { InfoPill } from '@lyearn/ui';
import { EventStatusEnum } from '@/types/schema';

function UsersRegisteredLabel({
  status,
  usersCount,
}: {
  status: EventStatusEnum;
  usersCount?: number;
}) {
  const { t } = useTranslation();

  if (!usersCount) {
    return null;
  }

  const label =
    status === EventStatusEnum.Completed
      ? t('Events:Manager.UserAttendee', { count: usersCount })
      : t('Events:Manager.UserRegistered', { count: usersCount });

  return (
    <InfoPill appearance="secondary" label={label} size="large" type="text" variant="outlined" />
  );
}

export default React.memo(UsersRegisteredLabel);
